export const wrapper = (centerAligned: boolean) => ({
	display: 'flex',
	textAlign: centerAligned ? 'center' : 'left',
	justifyContent: 'center',
	alignItems: centerAligned ? 'center' : 'start',
	width: '100%',
	padding: {
		xs: '0rem 1.563rem',
		sm: '2.625rem 1.5rem',
		md: '2.625rem 2.5rem',
	},
	maxWidth: {
		sm: '100%',
		md: '50%',
	},
});

export const textContainerStyles = (centerAligned: boolean) => ({
	display: 'flex',
	minWidth: { sm: '25.25rem' },
	maxWidth: '42.25rem',
	alignSelf: centerAligned ? 'center' : 'start',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: centerAligned ? 'center' : 'start',
	gap: '1rem',
	height: '100%',
});

export const ctaButtonWrapperStyles = (centerAligned: boolean) => ({
	display: 'flex',
	gap: '0.75rem',
	flexWrap: 'wrap',
	justifyContent: centerAligned ? 'center' : 'start',
	alignItems: centerAligned ? 'center' : 'start',
	paddingTop: '0.75rem',
	'& > a': {
		width: '192px',
	},
});

export const teamTagEyebrowOverrideStyles = {
	fontWeight: 700,
	letterSpacing: '3px',
	fontFamily: 'Messina Sans',
};
